import hardware from './hardware.dev'

const commonPlanProperties = {
    group_key: 'pro',
    label: 'Travel Ball',
    description: 'Travel Ball',
    stripe_product_id: 'prod_PU6zRJkzjLARkI',
    badge: '',
    free_hardware: true,
    free_hardware_categories: ['bat_attachment'],
    includes_coaching: false,
    hardware_options: hardware.filter((h) => {
        return (
            (h.category === 'bat_attachment' && h.price === 0) ||
            (h.category === 'short_bat' && h.price === 6930)
        )
    }),
    is_travel_ball: true,
}

const monthlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_monthly',
    billing_interval: 'monthly',
    price: 3900,
    price_monthly: 3900,
}

const yearlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_yearly',
    billing_interval: 'yearly',
    price: 35500,
    price_monthly: 2958,
}

const orgs = {
    'power-baseball': {
        name: 'Power Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Of8lnIDrm6Z6HgYSnsyF05b',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNGyIDrm6Z6HgYHzZMkGod',
            } as StripePlan,
        ],
    },
    'slammers': {
        name: 'Slammers',
        coupon: 'slammers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OgWxsIDrm6Z6HgYc9Vf0zCI',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            // {
            //     ...yearlyPlan,
            //     stripe_price_id: 'price_1OrNHIIDrm6Z6HgYvGw62GCW',
            // } as StripePlan,
        ],
    },
    'dulins-dodgers': {
        name: 'Dulins Dodgers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5aX2IDrm6Z6HgYvACzMQT1',
            } as StripePlan,
        ],
    },
    'iowa-sticks': {
        name: 'Iowa Sticks',
        coupon: 'iowasticks1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OjOVoIDrm6Z6HgYKra1818s',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
        ],
    },
    'marucci-elite': {
        name: 'Marucci Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OmO3MIDrm6Z6HgYTZCbMttx',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIUIDrm6Z6HgYCfbbrc1I',
            } as StripePlan,
        ],
    },
    'hunter-pence': {
        name: 'Hunter Pence',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OlxihIDrm6Z6HgYbEWtHxiP',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIFIDrm6Z6HgYR7GqjnhG',
            } as StripePlan,
        ],
    },
    'east-coast-development': {
        name: 'East Coast Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Olxi0IDrm6Z6HgYsJuIORyf',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNI3IDrm6Z6HgYmXCyRI6c',
            } as StripePlan,
        ],
    },
    'p2p-millers': {
        name: 'P2P Millers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Oo7WUIDrm6Z6HgYSMl52eNf',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIkIDrm6Z6HgY5sAYDv31',
            } as StripePlan,
        ],
    },
    'twelve-degree-launch': {
        name: 'Twelve Degree Launch',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OrNDRIDrm6Z6HgYsfpCZ9Zp',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNJ5IDrm6Z6HgYFOPDEJzj',
            } as StripePlan,
        ],
    },
    '5-star': {
        name: '5 Star',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Os8fIIDrm6Z6HgYt4bn0tFZ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Os8flIDrm6Z6HgY7xpQtsbN',
            } as StripePlan,
        ],
    },
    'east-cobb': {
        name: 'East Cobb',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OtFXpIDrm6Z6HgY6ozbzySs',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OtFY7IDrm6Z6HgYWMK3BShU',
            } as StripePlan,
        ],
    },
    'exposure': {
        name: 'eXposure',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXG5IDrm6Z6HgYTAxPh5hs',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXGCIDrm6Z6HgYqBzOWtuj',
            } as StripePlan,
        ],
    },
    'cba': {
        name: 'CBA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXI5IDrm6Z6HgYHMkrRrxR',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXIDIDrm6Z6HgYClZmUCBX',
            } as StripePlan,
        ],
    },
    'hardcore-elite': {
        name: 'Hardcore Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXIOIDrm6Z6HgYTcnyUYKO',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXIXIDrm6Z6HgYLvlCDqmE',
            } as StripePlan,
        ],
    },
    'lonestar': {
        name: 'Lonestar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXJMIDrm6Z6HgY6WfJ4pzz',
            } as StripePlan,
        ],
    },
    '3-step': {
        name: '3 Step',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMHIDrm6Z6HgY74ZS4COi',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXMQIDrm6Z6HgYL2MPhCiZ',
            } as StripePlan,
        ],
    },
    'knights-knation': {
        name: 'Knights Knation',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMaIDrm6Z6HgYkgNHW84i',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXMlIDrm6Z6HgYg3hHODfP',
            } as StripePlan,
        ],
    },
    'grb-rays': {
        name: 'GRB Rays',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMzIDrm6Z6HgY347GK9mH',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXN8IDrm6Z6HgYuslBRKxZ',
            } as StripePlan,
        ],
    },
    'gbg': {
        name: 'GBG',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXNIIDrm6Z6HgYmrH0G1dG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXNTIDrm6Z6HgYdnMPFALD',
            } as StripePlan,
        ],
    },
    'ebc': {
        name: 'EBC',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXNcIDrm6Z6HgY6wnPIDOQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXNmIDrm6Z6HgYyL77al0o',
            } as StripePlan,
        ],
    },
    'indiana-bulls': {
        name: 'Indiana Bulls',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXoJIDrm6Z6HgY0BxtmX3A',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXoSIDrm6Z6HgYOheCwcnI',
            } as StripePlan,
        ],
    },
    'select1': {
        name: 'WIN Player Development Program',
        alias: 'All Star Sports Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXoiIDrm6Z6HgYZfubDk8H',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXoqIDrm6Z6HgYT9tuND0d',
            } as StripePlan,
        ],
    },
    'the-show-new-england': {
        name: 'The Show New England',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXLvIDrm6Z6HgYDP77u9YM',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXM5IDrm6Z6HgY0wUbKHKI',
            } as StripePlan,
        ],
    },
    'noreasters': {
        name: 'Nor\'Easters',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOGnIDrm6Z6HgYOlB8A2Ns',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOGzIDrm6Z6HgYGwgrJqbX',
            } as StripePlan,
        ],
    },
    'prospects-athletics': {
        name: 'Prospects Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOHHIDrm6Z6HgYLgf26OCQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOHPIDrm6Z6HgY3cw4tp3b',
            } as StripePlan,
        ],
    },
    'bay-sox': {
        name: 'Bay Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOJ3IDrm6Z6HgY8QB9F0Gq',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOJHIDrm6Z6HgY0TkTZTEr',
            } as StripePlan,
        ],
    },
    'seacoast': {
        name: 'Seacoast',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOMKIDrm6Z6HgYcPVrw06j',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOMbIDrm6Z6HgYbUh2xNWh',
            } as StripePlan,
        ],
    },
    'northeast-hurricanes': {
        name: 'Northeast Hurricanes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOO4IDrm6Z6HgY45l7vedj',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOOFIDrm6Z6HgYqmR4iNyg',
            } as StripePlan,
        ],
    },
    'midland': {
        name: 'Midland',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPPTIDrm6Z6HgYZsozeCWI',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPPdIDrm6Z6HgYRGUVMcQ2',
            } as StripePlan,
        ],
    },
    'grb-stiks': {
        name: 'GRB STiKS',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2Hb0IDrm6Z6HgYa3jDT9FA',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HbEIDrm6Z6HgYkashcvv4',
            } as StripePlan,
        ],
    },
    'grb-illinois': {
        name: 'GRB Illinois',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2He9IDrm6Z6HgYgkXEWgcA',
            } as StripePlan,
        ],
    },
    'grb-northstar': {
        name: 'GRB Northstar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HekIDrm6Z6HgYA4mokjSw',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HetIDrm6Z6HgYjIDKAl2u',
            } as StripePlan,
        ],
    },
    'dakota-select': {
        name: 'Dakota Select',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HfDIDrm6Z6HgYTMjTYbrG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HfQIDrm6Z6HgYOR2ATdIK',
            } as StripePlan,
        ],
    },
    'clubhouse-ct': {
        name: 'Clubhouse CT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mrRIDrm6Z6HgYGsdugqhT',
                price: 9900,
                price_monthly: 9900,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mrnIDrm6Z6HgY4wn2aL0z',
                price: 99900,
                price_monthly: 8325,
            } as StripePlan,
        ],
    },
    'wildcats-baseball': {
        name: 'Wildcats Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3ms9IDrm6Z6HgYoW2PK3Ll',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3msPIDrm6Z6HgY2q7VPzCB',
            } as StripePlan,
        ],
    },
    'original-florida-pokers': {
        name: 'Original Florida Pokers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mslIDrm6Z6HgY6937NJpY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mu5IDrm6Z6HgYyEvl3ZwX',
            } as StripePlan,
        ],
    },
    'midland-marlins': {
        name: 'Midland Marlins',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3myEIDrm6Z6HgY2IKwF2CS',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3myPIDrm6Z6HgYTddPQYtb',
            } as StripePlan,
        ],
    },
    'cooperstown-cobras': {
        name: 'Cooperstown Cobras',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mykIDrm6Z6HgYSG1u3VM9',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mzQIDrm6Z6HgYuZz23EvV',
            } as StripePlan,
        ],
    },
    'canes': {
        name: 'Canes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pNRIDrm6Z6HgYOLnxo3WY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pNcIDrm6Z6HgYRkueZtRG',
            } as StripePlan,
        ],
    },
    'd-bat': {
        name: 'D-Bat',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pOFIDrm6Z6HgYXQnI2mok',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pOSIDrm6Z6HgYUWkS4CHx',
            } as StripePlan,
        ],
    },
    'select2': {
        name: 'WIN Player Development Program',
        alias: 'Tim Dulin',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5adcIDrm6Z6HgYmUwLywVg',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P5ae2IDrm6Z6HgYIHgTwWW0',
            } as StripePlan,
        ],
    },
    'select3': {
        name: 'WIN Player Development Program',
        alias: 'Baseball USA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P6b9RIDrm6Z6HgYdbzxkt5R',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P6b9cIDrm6Z6HgYBuZitN4W',
            } as StripePlan,
        ],
    },
    'sc-panthers': {
        name: 'SC Panthers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P731xIDrm6Z6HgYHehdJCZ4',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P7328IDrm6Z6HgYJDyN2Ikx',
            } as StripePlan,
        ],
    },
    'grb-north': {
        name: 'GRB North',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8NrjIDrm6Z6HgYWJw1WeRM',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8NsCIDrm6Z6HgYWsenBukg',
            } as StripePlan,
        ],
    },
    'tbt': {
        name: 'TBT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W0OIDrm6Z6HgYNvyf4oC4',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W0YIDrm6Z6HgYBrSLVaTF',
            } as StripePlan,
        ],
    },
    'texas-glory': {
        name: 'Texas Glory',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W0kIDrm6Z6HgYRh4XyETe',
            } as StripePlan,
        ],
    },
    'select4': {
        name: 'WIN Player Development Program',
        alias: 'Sean Danielson',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W17IDrm6Z6HgYLRclIVtg',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W1GIDrm6Z6HgYy1kr5DyL',
            } as StripePlan,
        ],
    },
    'dingers-batting-cages': {
        name: 'Dingers Batting Cages',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W1PIDrm6Z6HgYuRrslyqY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W1aIDrm6Z6HgYcf0oaEpz',
            } as StripePlan,
        ],
    },
    'new-level-baseball': {
        name: 'New Level Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8pz6IDrm6Z6HgY96Pw3kHH',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8pzGIDrm6Z6HgYAMUWoshT',
            } as StripePlan,
        ],
    },
    'waco-storm': {
        name: 'Waco Storm',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8pzPIDrm6Z6HgYlpNelzlu',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8pzZIDrm6Z6HgYKrFITpw3',
            } as StripePlan,
        ],
    },
    'oklahoma-fuel': {
        name: 'Oklahoma Fuel',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8pzkIDrm6Z6HgY121d6kro',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8pztIDrm6Z6HgYtBHdkIJv',
            } as StripePlan,
        ],
    },
    'ninth-inning-royals': {
        name: 'Ninth Inning Royals',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC2TPIDrm6Z6HgYijWVfWEX',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC2TeIDrm6Z6HgYp7nSBVrz',
            },
        ],
    },
    'vipers-sting': {
        name: 'Vipers-Sting',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PBPPjIDrm6Z6HgYcnbDz5iv',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PBPPuIDrm6Z6HgYnbbhke8j',
            },
        ],
    },
    'texas-generals': {
        name: 'Texas Generals',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC2c1IDrm6Z6HgYHYPdYB7N',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC2cBIDrm6Z6HgYd999JhF0',
            },
        ],
    },
    'citius-baseball': {
        name: 'Citius Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC2caIDrm6Z6HgY7U0YT6Ph',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC2cqIDrm6Z6HgYKBLt7gZi',
            },
        ],
    },
    'texoma-baseball-academy': {
        name: 'Texoma Baseball Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC2deIDrm6Z6HgYYrxYSMrp',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC2dpIDrm6Z6HgYBV4hTjkc',
            },
        ],
    },
    'stars-showcase-baseball': {
        name: 'Stars Showcase Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC2eYIDrm6Z6HgY5izQCxY5',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC2elIDrm6Z6HgYY2IqIexE',
            },
        ],
    },
    'florida-burn': {
        name: 'Florida Burn',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3HoIDrm6Z6HgYs3cRVZBQ',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3HyIDrm6Z6HgYsjV4TZV9',
            },
        ],
    },
    'texas-cannons': {
        name: 'Texas Cannons',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3IHIDrm6Z6HgYiyDE5O5s',
            },
        ],
    },
    'ej-sports': {
        name: 'EJ Sports',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3IjIDrm6Z6HgYk2wrwzR9',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3ItIDrm6Z6HgYmeXROylH',
            },
        ],
    },
    'v8-baseball': {
        name: 'V8 Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3JDIDrm6Z6HgYaV8RdT6n',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3JOIDrm6Z6HgYOJa07ZQf',
            },
        ],
    },
    'unleashed-sports-group': {
        name: 'Unleashed Sports Group',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3JhIDrm6Z6HgYkRvzbf4s',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3JrIDrm6Z6HgY97Hie5il',
            },
        ],
    },
    'cangelosi-sparks': {
        name: 'Cangelosi Sparks',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3KFIDrm6Z6HgYb4bbvtH9',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3KPIDrm6Z6HgYApsCwzZA',
            },
        ],
    },
    'dallas-baseball-club': {
        name: 'Dallas Baseball Club',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3KgIDrm6Z6HgYatQiY0ir',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3KrIDrm6Z6HgY2c1cWLnc',
            },
        ],
    },
    'action-baseball': {
        name: 'Action Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3L7IDrm6Z6HgYTWdLd354',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3LHIDrm6Z6HgYvCCzspm1',
            },
        ],
    },
    'texas-crew-baseball': {
        name: 'Texas Crew Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqOfIDrm6Z6HgYU5HKgMLc',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqOpIDrm6Z6HgYf8nTWRz5',
            },
        ],
    },
    'cavalry-baseball': {
        name: 'Cavalry Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqPBIDrm6Z6HgYTiLnPDHu',
            },
        ],
    },
    'buzz-lightning-baseball-academy': {
        name: 'Buzz Lightning Baseball Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqPYIDrm6Z6HgYrPTHepfw',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqPiIDrm6Z6HgYYPQdPiZP',
            },
        ],
    },
    'dirtbags': {
        name: 'Dirtbags',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqQMIDrm6Z6HgYS4mdoJwX',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqQWIDrm6Z6HgYe1pFAce2',
            },
        ],
    },
    'athletes-lab': {
        name: 'Athletes Lab',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqQpIDrm6Z6HgYOSYAsFDP',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqRBIDrm6Z6HgYfmvdnEqR',
            },
        ],
    },
    'north-texas-longhorns': {
        name: 'North Texas Longhorns',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqRUIDrm6Z6HgYyntv2jPG',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqReIDrm6Z6HgY0vQnGBKj',
            },
        ],
    },
    'off-speed-athletics': {
        name: 'Off Speed Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PE9JwIDrm6Z6HgYnZZ1bt26',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PE9KSIDrm6Z6HgYcclJjFjt',
            },
        ],
    },
    'midland-titans': {
        name: 'Midland Titans',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PE9M0IDrm6Z6HgY7XbEN0e9',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PE9MQIDrm6Z6HgYG727xr0b',
            },
        ],
    },
    'pbr': {
        name: 'Prep Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OD93NIDrm6Z6HgYXYSMYj6M',
            },
        ],
        coupon: 'PBRdiscount',
    },
    'rawlings-tigers': {
        name: 'Rawlings Tigers',
        // coupon: 'RawlingsTigers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PTRcwIDrm6Z6HgYIeZsHimY',
                trial_days: 30,
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PTRd7IDrm6Z6HgYvD4fzAQ3',
                trial_days: 30,
            },
        ],
    },
    'texas-twelve-baseball': { // price IDs from Rawlings Tigers, only for testing purposes
        name: 'Texas Twelve - Baseball',
        message: '30-day Free Access: Offseason Credit',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PTRcwIDrm6Z6HgYIeZsHimY',
                price: 4000,
                price_monthly: 4000,
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PTRd7IDrm6Z6HgYvD4fzAQ3',
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
        ],
    },
    'team-elite': {
        name: 'Team Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXnkIDrm6Z6HgYoFOhj5EG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXnvIDrm6Z6HgYq6fsgtHg',
            } as StripePlan,
        ],
    },
} as Record<string, Org>

export default orgs